import { render, staticRenderFns } from "./CustomerTap.vue?vue&type=template&id=464181db&"
import script from "./CustomerTap.vue?vue&type=script&lang=js&"
export * from "./CustomerTap.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTap.vue?vue&type=style&index=0&id=464181db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports